export const contactPage = {
  image: "/images/brand/contact-hero.webp",
  seoTitle: "Contact General Applications | Discuss AI, Search & Systems",
  seoDescription:
    "Talk with General Applications about applied AI, search, data systems, workflow automation, software architecture, or another difficult operational problem.",
  headline: "Start with the problem **as it exists**.",
  heroCopy: [
    "Bring the difficult workflow, fragmented information, search problem, legacy platform, or AI initiative that is not yet producing a dependable result.",
    "You do not need a finished requirements document. A clear description of the current state, the most important constraint, and what a better outcome would look like is enough to begin.",
    "The goal of the first conversation is simple: clarify the problem, the constraint, and whether the next useful move is assessment, planning, implementation, or a focused prototype.",
  ],
  formIntro:
    "Tell us what you are trying to improve and where the work is getting stuck.",
  fields: [
    "Name",
    "Work email",
    "Organization",
    "Role or team",
    "What are you trying to improve?",
  ],
  interests: [
    "Intelligent systems and applied AI",
    "Data, search, or knowledge systems",
    "Automation and operational tooling",
    "Software architecture and engineering",
    "Technical strategy or architecture review",
    "Something else",
  ],
  submitLabel: "Start a Conversation",
  submittingLabel: "Sending...",
  alternateContact:
    "Every submission is read personally and treated as the beginning of a practical engineering conversation.",
  successMessage: "Thanks. Your message has been received.",
  genericErrorMessage:
    "Something went wrong sending that. Please try again in a moment.",
  rateLimitMessage:
    "That is a few in a row. Please wait a few minutes before sending another.",
} as const;
